export default import.meta.ROLLDOWN_FILE_URL_cJinY8z6HkMOTftdW$lZyA